"use client"

/**
 * SibViewportWrapper
 * Shrinks the app viewport height when the SIB player is active,
 * so the player occupies its own dedicated space below the app.
 * No fixed element inside the app needs individual offsetting.
 *
 * Layout when SIB active:
 * ┌─────────────────────┐  calc(100dvh - playerHeight)
 * │   Entire app        │
 * └─────────────────────┘
 * ┌─────────────────────┐  playerHeight (48px min / 80px normal)
 * │   SIB Player        │
 * └─────────────────────┘
 */

import { useEffect } from "react"
import { useSibStore } from "@/lib/sib-store"

export function SibViewportWrapper() {
  const { isVisible, isMinimized } = useSibStore()

  useEffect(() => {
    const playerHeight = !isVisible ? 0 : isMinimized ? 48 : 80
    document.documentElement.style.setProperty("--sib-player-height", `${playerHeight}px`)
  }, [isVisible, isMinimized])

  // This component only sets the CSS variable — renders nothing
  return null
}
